import SharedAsset from '@zenbusiness/zui/SharedAsset';

import useBreakpoints from '#client/hooks/useBreakpoints';

import {
  DescriptionSessionStyled,
  DescriptionStyled,
  EmptyStatementWrapperStyled,
  MainContentWrapStyled,
  TitleStyled
} from './EmptyStatement.styles';

export default function EmptyStatement() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <EmptyStatementWrapperStyled>
      <MainContentWrapStyled>
        <SharedAsset
          alt=""
          src="/icon/product/no-documents.svg"
          width={isDesktop ? 256 : 128}
        />
        <DescriptionSessionStyled>
          <TitleStyled>No Documents</TitleStyled>
          <DescriptionStyled>
            You don&apos;t have any documents yet. As monthly statements and other banking documents
            are generated, those will be added here.
          </DescriptionStyled>
        </DescriptionSessionStyled>
      </MainContentWrapStyled>
    </EmptyStatementWrapperStyled>
  );
}
